module.exports = __webpack_public_path__ + "img/music_001.f419508a.png";